import VueRouter from "vue-router";

// 路由异步加载
const BindMobile = (resolve) => {
    import('./components/bindmobile.vue').then((module) => {
        resolve(module);
    })
}
const Login = (resolve) => {
    import('./components/Login.vue').then((module) => {
        resolve(module);
    })
}
const Index = (resolve) => {
    import('./components/Index.vue').then((module) => {
        resolve(module);
    })
}
const Overview = (resolve) => {
    import('./components/Overview.vue').then((module) => {
        resolve(module);
    })
}
const benifitsearch = (resolve) => {
    import('./components/benifitsearch.vue').then((module) => {
        resolve(module);
    })
}
const SubRelation = (resolve) => {
    import('./components/SubRelation.vue').then((module) => {
        resolve(module);
    })
}

const contrlWay = (resolve) => {
    import('./components/contrlWay.vue').then((module) => {
        resolve(module);
    })
}
const fatftable = (resolve) => {
    import('./components/fatftable.vue').then((module) => {
        resolve(module);
    })
}
const lookMyRelation = (resolve) => {
    import('./components/lookMyRelation.vue').then((module) => {
        resolve(module);
    })
}


//路由清单
const routes = [
    {
        path : "/login" ,
        title : "登陆",
        name : "login",
        component : Login
    },
    {
        path:'/bindmobile/:bind',
        component: BindMobile,
        name: '绑定手机号'
    },
    {
        path : "/index" ,
        title : "首页",
        name : "index",
        component :Index,
        meta:{
            requireLogin : true
        },
        children : [
            {
                path : "overview" ,
                title : "全貌查询" ,
                name : "overview" ,
                meta:{
                    requireLogin : true
                },
                component : Overview
            },
            {
                path : "benifitsearch" ,
                title : "受益人查询" ,
                name : "benifitsearch" ,
                meta:{
                    requireLogin : true
                },
                component : benifitsearch
            },
            {
                path : "subrelation" ,
                title : "实质关联" ,
                name : "subrelation" ,
                meta:{
                    requireLogin : true
                },
                component : SubRelation
            },
            {
                path : "contrlWay" ,
                title : "控制路径" ,
                name : "contrlWay" ,
                meta:{
                    requireLogin : true
                },
                component : contrlWay
            },
            {
                path : "fatftable" ,
                title : "资料列表",
                name : "fatftable",
                meta:{
                    requireLogin : true
                },
                component : fatftable
            }

        ]
    },
    {
        path : "/entRelation" ,
        title : "图族",
        name : "entRelation",
        component : require('./components/EntRelation.vue')
    },

    {
        path : "/ImportEnt" ,
        title : "输入页",
        name : "ImportEnt",
        component : require('./components/ImportEnt.vue')
    },
    {
        path : "/ModuleCate" ,
        title : "企业分类",
        name : "ModuleCate",
        meta:{
            requireLogin : true
        },
        component : require('./components/ModuleCate.vue')
    },
    {
        path : "/lookMyrelation" ,
        title : "查看我的图谱",
        name : "lookMyrelation",
        meta:{
            requireLogin : true
        },
        component : lookMyRelation
    },
    {
        path : "/*" ,
        // 重定向
        redirect : "/login"
    }
];

const router = new VueRouter({
    routes
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.config.js